// Minimal reportWebVitals stub used by CRA template.
// You can replace with full implementation if you want to measure perf.

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    // no-op for now; you can send metrics to analytics
    // Example: import('web-vitals').then(({getCLS, getFID, getFCP, getLCP, getTTFB}) => { ... })
  }
};

export default reportWebVitals;
